import React from 'react';
import { Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  container: {
    height: theme.spacing(31),
    width: '100%',
    backgroundColor: theme.palette.insights.noData,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const MyUtilizationChartNoData: React.FC = () => {
  const classes = useStyles();
  return (
    <Paper
      className={classes.container}
      elevation={0}
      data-testid={'my-utilization-chart-no-data-container'}
    >
      <Typography variant="body2">
        <FormattedMessage id={'insights.timeUtilizationChart.noDataMessage'} />
      </Typography>
    </Paper>
  );
};

export default React.memo(MyUtilizationChartNoData);
